<div class="login">
  <div>
    <button (click)="closeDialog()" class="closeHeader" id="closeBtn">
      <img
        src="./assets/images/close cross.svg"
        alt="Close Icon">
    </button>
  </div>
  <div class="content row">
    <form
      #loginForm="ngForm"
      id="loginForm"
      [class.d-none]="initialLogin">
      <div class="header text-start">
        {{ welcomeBack ? 'Welcome Back' : 'Login' }}
      </div>
      <div class="Form">
        <div class="loginForm mt-2 mb-2">
          <label for="email">Email Address</label>
          <input
            type="email"
            id="email"
            placeholder="Email Address"
            [(ngModel)]="login.email"
            name="email"
            maxlength="100"
            [disabled]="welcomeBack"/>
        </div>
        <div class="loginForm mb-2">
          <label for="password">Password</label>
          <input
            type="password"
            id="password"
            placeholder="Password"
            [(ngModel)]="login.password"
            name="password"
            maxlength="30"/>
        </div>
        <div
          class="row error"
          [innerHTML]="loginErrorMessage">
        </div>
        <div class="mb-2 mt-2">
          <a
            class="fpassword"
            id="fpassword"
            (click)="OpenForgotPasswordDialog()"
            >Forgot Password?</a>
        </div>
        <div>
          <button
            class="logIn"
            id="loginBtn"
            type="submit"
            (click)="onClickLogin()"
            [innerHTML]="loginBtnText"
            ></button>
        </div>
      </div>
    </form>

    <form
      #otpForm="ngForm"
      id="otpForm"
      [class.d-none]="!initialLogin">
      <div class="header text-start">
        Enter Verification Code
      </div>
      <div>
        Please enter the verification code sent to your email address.
      </div>
      <div class="Form">
        <div class="loginForm mt-2 mb-2">
          <label for="otp">Verification Code</label>
          <input
            type="text"
            id="otp"
            placeholder="Enter Verification Code"
            [(ngModel)]="otp"
            name="otp"
            [maxlength]="otpLength"
          />
        </div>
        <div
          class="row error mb-1"
          [innerHTML]="otpErrorMessage">
        </div>
        <div>
          <a
            class="resend"
            (click)="sendOTP(true)"
            *ngIf="!resendingOTP">Resend Verification Code</a>
          <div *ngIf="resendingOTP">
            <a class="otp-resent" [class.text-success]="resentOTP">{{ resentOTP ? "Verification Code sent!" : "Resending Verification Code..." }}</a>
          </div>
          <div *ngIf="resendingOTP && resentOTPError">
            <a class="otp-resent-error text-danger">Failed to resend Verification Code.<br>Please try again.</a>
          </div>
          <div class="divider"></div>
          <button
            class="logIn"
            id="verifyBtn"
            type="submit"
            (click)="validateOTP()"
            [innerHTML]="verifyBtnText"
            ></button>
        </div>
      </div>
    </form>
  </div>
</div>
